
import { jsPDF } from "jspdf";

export const renderTitle = (pdf: jsPDF, title: string, yPosition: number, pageWidth: number, margin: number) => {
  pdf.setFont(undefined, 'bold');
  pdf.setFontSize(22);
  pdf.setTextColor(26, 31, 44);
  const titleLines = pdf.splitTextToSize(title, pageWidth - (margin * 2));
  pdf.text(titleLines, margin, yPosition + 10);
  return (titleLines.length * 10) + 15;
};

export const renderMetadata = (
  pdf: jsPDF, 
  fullName: string, 
  scenarioType: string | null, 
  yPosition: number, 
  margin: number
) => {
  let metadataY = yPosition;
  
  // Created by
  pdf.setFontSize(11);
  pdf.setTextColor(142, 145, 150);
  pdf.setFont(undefined, 'normal');
  pdf.text(`Created by ${fullName}`, margin, metadataY);
  metadataY += 15;

  // Scenario type with refined badge style
  if (scenarioType) {
    pdf.setFillColor(241, 240, 251);
    const scenarioText = `Scenario: ${scenarioType}`;
    const badgeWidth = pdf.getTextWidth(scenarioText) + 10;
    pdf.roundedRect(margin - 2, metadataY - 5, badgeWidth, 10, 2, 2, 'F');
    pdf.setTextColor(155, 135, 245);
    pdf.text(scenarioText, margin + 3, metadataY);
    metadataY += 20;
  }

  return metadataY;
};

export const renderAnalysis = (
  pdf: jsPDF, 
  analysisText: string, 
  yPosition: number, 
  pageWidth: number, 
  margin: number
) => {
  pdf.setFontSize(16);
  pdf.setTextColor(26, 31, 44);
  pdf.setFont(undefined, 'bold');
  pdf.text('Analysis Results', margin, yPosition);
  yPosition += 12;

  pdf.setFontSize(10);
  pdf.setTextColor(71, 85, 105);
  pdf.setFont(undefined, 'normal');

  const paragraphs = analysisText.split('\n');
  for (const paragraph of paragraphs) {
    if (paragraph.trim()) {
      // Check for section headers
      if (paragraph.includes('**Key Findings**') || paragraph.includes('**Recommendations**')) {
        const cleanHeader = paragraph.replace(/\*\*/g, '');
        pdf.setFont(undefined, 'bold');
        pdf.setTextColor(26, 31, 44);
        pdf.setFontSize(12);
        pdf.text(cleanHeader, margin, yPosition);
        yPosition += 8;
        continue;
      }

      const isBulletPoint = paragraph.trim().startsWith('-');
      const textWidth = pageWidth - (margin * 2) - (isBulletPoint ? 10 : 0);
      const textMargin = isBulletPoint ? margin + 8 : margin;
      
      const cleanText = paragraph.replace(/\*\*/g, '');
      const lines = pdf.splitTextToSize(
        isBulletPoint ? cleanText.substring(1) : cleanText,
        textWidth
      );

      pdf.setFont(undefined, 'normal');
      pdf.setTextColor(71, 85, 105);
      pdf.setFontSize(10);

      if (isBulletPoint) {
        pdf.setTextColor(155, 135, 245);
        pdf.circle(margin + 3, yPosition - 2, 1, 'F');
        pdf.setTextColor(71, 85, 105);
      }

      pdf.text(lines, textMargin, yPosition);
      yPosition += (lines.length * 5) + 3;
    }
  }

  return yPosition;
};
